export class StudioPlugin {
    constructor(name) {
        this.name = name;
    }

    init(studio) {
        this.studio = studio;
    }

    dispose() {

    }
}


// WEBPACK FOOTER //
// ./src/js/define/StudioPlugin.js